import config from "@config";
const datePickerOptions = {
  placeholder: "dd/mm/yyyy",
  dateFormat: config.dateFormatBE,
};

export default {
  id: {
    "ui:title": "Position ID",
    "ui:disabled": true,
  },
  fte: {
    "ui:title": "FTE",
    "ui:widget": "number-input",
  },
  weeklyContractedHoursInSeconds: {
    "ui:widget": "seconds-as-hours-input",
  },
  organisationalUnit: {
    "ui:widget": "radio-hierarchy-tree-modal",
  },
  shiftPattern: {
    "ui:widget": "select",
  },
  activeFrom: {
    "ui:widget": "date-picker",
    "ui:options": datePickerOptions,
  },
  activeTo: {
    "ui:widget": "date-picker",
    "ui:options": datePickerOptions,
  },
  isActive: {
    "ui:widget": "hidden",
  },

  "ui:order": [
    "id",
    "status",
    "activeFrom",
    "activeTo",
    "employeePositionReference",
    "jobTitle",
    "staffGroup",
    "organisationalUnit",
    "fte",
    "weeklyContractedHoursInSeconds",
    "daysPerYear",
    "shiftPattern",
    "salary",
    "isActive",
  ],
};
